<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container">
        <img
          style="width: 100%; height: 100%"
          :src="$t('picture.recruit')"
          alt=""
        />
      </div>
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title">{{ $t("recruit.closeLoop") }}</div>

        <div>
          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('recruit.adver')" name="first">
              <div class="portus_solution">
                <div class="guang_widthHeight">
                  <img src="../../public/static/img/recruit/guang.png" alt="" />
                </div>
                <div class="right_explain ml108">
                  <div class="explain_title">{{ $t("recruit.adver") }}</div>
                  <div class="explain_content mb39">
                    {{ $t("recruit.adver1") }}
                  </div>
                  <div class="explain_content">
                    {{ $t("recruit.adver2") }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('recruit.channel')" name="second">
              <div class="pl92">
                <div class="channelFont" style="">
                  {{ $t("recruit.channel") }}
                </div>
                <div class="channel_font">
                  {{ $t("recruit.channel_") }}
                </div>
              </div>
              <div class="channel_drainage">
                <div>
                  <div class="app_widthHeight">
                    <img
                      src="../../public/static/img/recruit/zhang.png"
                      alt=""
                    />
                  </div>
                  <div class="tac">{{ $t("recruit.beijing") }}</div>
                </div>
                <div>
                  <div class="app_widthHeight">
                    <img src="../../public/static/img/recruit/fa.png" alt="" />
                  </div>
                  <div class="tac">{{ $t("recruit.guangfa") }}</div>
                </div>
                <div>
                  <div class="app_widthHeight">
                    <img
                      src="../../public/static/img/recruit/zhong.png"
                      alt=""
                    />
                  </div>
                  <div class="tac">{{ $t("recruit.ICBC") }}</div>
                </div>
                <div>
                  <div class="app_widthHeight">
                    <img src="../../public/static/img/recruit/yin.png" alt="" />
                  </div>
                  <div class="tac">{{ $t("recruit.union") }}</div>
                </div>
                <div>
                  <div class="app_widthHeight">
                    <img
                      src="../../public/static/img/recruit/shan.png"
                      alt=""
                    />
                  </div>
                  <div class="tac">{{ $t("recruit.CCB") }}</div>
                </div>
                <div>
                  <div class="app_widthHeight">
                    <img src="../../public/static/img/recruit/jin.png" alt="" />
                  </div>
                  <div class="tac">{{ $t("recruit.jinzhou") }}</div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('recruit.platform')" name="third">
              <div class="portus_solution">
                <div class="platform_widthHeight">
                  <img src="../../public/static/img/recruit/ping.png" alt="" />
                </div>
                <div class="right_explain ml108">
                  <div class="explain_title">{{ $t("recruit.platform") }}</div>
                  <div class="explain_content mb39">
                    {{ $t("recruit.platform_") }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('recruit.vip')" name="fourth">
              <div class="portus_solution">
                <div class="vip_widthHeight">
                  <img src="../../public/static/img/recruit/hui.png" alt="" />
                </div>
                <div class="right_explain ml108">
                  <div class="explain_title">{{ $t("recruit.vip") }}</div>
                  <div class="explain_content mb39">
                    {{ $t("recruit.vip_") }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <div class="banner_box_media" style="background-color: #f7f7f7">
      <div class="banner_center_media" style="position: relative">
        <div class="media_title">{{ $t("travel.recruit") }}</div>
        <el-carousel
          indicator-position="none"
          :interval="4000"
          type="card"
          arrow="always"
        >
          <el-carousel-item v-for="(item, index) in swiperList" :key="index">
            <template>
              <div class="swiper_widthHeight">
                <img :src="item" alt="" />
              </div>
            </template>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      swiperList: [
        this.$i18n.t('picture.swiper1'),
        this.$i18n.t('picture.swiper2'),
        this.$i18n.t('picture.swiper3'),
        this.$i18n.t('picture.swiper4'),
        this.$i18n.t('picture.swiper5')
      ],
      arr: []
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-carousel__container {
  height: 580px;
}
/deep/ .el-carousel__container .is-active {
  margin-left: 0 !important;
  transform: translateX(50%) scale(0.83) !important;
}
/deep/ .el-tabs__nav .is-active {
  margin-left: 0 !important;
}
/deep/ .el-carousel__container .el-carousel__item--card {
  padding-left: 100px;
}
/deep/ .el-tabs__item {
  font-size: 28px;
  color: #636363;
}
/deep/ .el-tabs__item:hover {
  color: #424242;
  cursor: pointer;
}
/deep/ .el-tabs__active-bar {
  background-color: #000;
}
/deep/ .el-tabs__item.is-active {
  color: #424242;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: transparent;
}
/deep/ .el-tabs__item {
  padding: 0 50px;
}
/deep/ .el-tabs__nav-scroll {
  display: flex;
  justify-content: space-around;
}
/deep/ .el-tabs__header {
  margin: 0 0 50px;
}

// 轮播图
/deep/ .el-carousel__arrow {
  background-color: transparent;
  border: 2px solid #f4bc1c;
  color: #f4bc1c;
  font-size: 35px;
  width: 54px;
  height: 54px;
}
/deep/ .el-carousel__arrow--left {
  left: 0;
}
/deep/ .is-active {
  margin-left: 119px;
}
/deep/ .el-carousel__mask {
  background-color: transparent;
}
// /deep/ .el-carousel__container:first-child {
//   transform: translateX(898.642px) scale(1);
// }
// /deep/ .el-carousel__container:last-child {
//   transform: translateX(450px) scale(1);
// }
// /deep/ .el-carousel__container .el-carousel__item--card {
//   transform: scale(1);
// }
.banner .banner-container {
  padding-top: 86px;
  min-height: 638px;
  // background-image: url("http://travelmall.portus.cn/2023/04/799ba8b4d7394b38809577964d4e68f1.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
</style>